import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import OpeningHours from '../general-components/opening-hours';

class SimpleNavigation extends Component {
  render() {
    return (
      <div id="navigation" className={"container-fluid " + (this.props.menuOpen === true ? 'active' : '')}>
        <div className="row">
          <div className="nav-wrapper">
            <ul>
              {this.props.mainMenuQuery.menuByName.links.map((item, index) =>
                <li>
                  <a href={item.url.path}>{item.label}</a>
                </li>
              )}
            </ul>
            <div className="notice-wrapper">
              <div className="notice">
                <div className="image">
                  <img src="/themes/custom/module_box/src/images/icon-Hund.svg"/>
                </div>
                <div className="text">
                  {this.props.t('Hunde dürfen leider nicht mit in das Museum mitbringen')}
                </div>
              </div>
              <div className="notice">
                <div className="image">
                  <img src="/themes/custom/module_box/src/images/icon-Essen.svg"/>
                </div>
                <div className="text">
                  {this.props.t('Bitte keine Lebensmittel mit in das Museum nehmen')}
                </div>
              </div>
            </div>
            <div className="info-wrapper">
              <div className="notice">
                <div className="image">
                  <img src="/themes/custom/module_box/src/images/icon-Brief.svg"/>
                </div>
                <div className="text">
                  {this.props.t('Kontakt')}:<br/>
                  <a href="mailto:info@kindermuseum-unikatum.de">info(at)kindermuseum-unikatum.de</a>
                </div>
              </div>
              <div className="notice">
                <div className="image">
                  <img src="/themes/custom/module_box/src/images/Oeffnungszeit-Uhr.svg"/>
                </div>
                <div className="text">
                  {this.props.t('Heute geöffnet')}
                  <OpeningHours />
                </div>
              </div>
              {this.props.mainMenuQuery.footerConfig.fieldFaqSeite.url.path &&
                <div className="notice">
                  <div className="image">
                    <img src="/themes/custom/module_box/src/images/FAQ-haeufige_Fragen-svg.svg"/>
                  </div>
                  <div className="text">
                    <a href={this.props.mainMenuQuery.footerConfig.fieldFaqSeite.url.path}>
                      {this.props.t('Häufig gestellte Fragen')}
                    </a>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(SimpleNavigation);
